export default __webpack_public_path__ + "static/media/newcarousel.d187fd13.jpeg";